module.exports = __webpack_public_path__ + "img/blog-10-770x420.499ed7cd.jpg";